<template>
  <section  class="relative md:absolute lg:static h-full overflow-hidden" >
  <section @click="checkIfOnBottom" ref="mainContainer"  class="purple-small-scroll overflow-auto max-h-full"  :class="[isDiscoverExpanded && isAtLargeScreen ? 'hidden lg:block' : '', 'md:hidden']" >

    <div  ref="scrollContainer" class="h-auto">
      <section  v-if="hasRecommendedChatRoom" class="overflow-hidden p-2 " >

      <div class="text-purple-600 w-full flex justify-between">
        <h6 class="text-base xl:text-lg my-auto">Discover Chat Room</h6>

        <div v-if="isAtLargeScreen" @click="$emit('toggleIsDiscoverExpanded')" class="text-2xl bg-purple-300 rounded-full p-2 flex bg-opacity-10 hover:bg-opacity-50 pop-click">
          <ion-icon   name="log-in"></ion-icon>
        </div>
      </div>
      
      <div @click="toggleSearchChat(true)" class="my-3 text-gray-400 shadow-sm bg-white rounded-md pop-click flex space-x-2 cursor-text px-1 py-3">
        <ion-icon class="-mb-4" name="search"></ion-icon>
        <h6 class="text-sm my-auto">Search Chat Room</h6>
      </div>

      <div name="slide-up" tag="div" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 gap-2 w-full max-w-sm mx-auto sm:max-w-full">
        <chat-room-card class="w-full mx-auto" v-for="(room,key) in recommendedChatRoom" :key="key" :chatRoom="room" :chatRoomId="key" @joinChatRoom="()=>{ $emit('joinChatRoom',key) }"  @errorIcon="()=>{ $emit('errorIcon',key) }" @setChatRoomInfo="(room,key,isAlreadyMember)=>{ $emit('setChatRoomInfo',room,key,isAlreadyMember)}" :isAlreadyMember="false" ></chat-room-card>
      </div>

      <google-loader v-if="isAddingDiscoverChatRoom"></google-loader>
     
      </section>

      <section v-else class="space-y-5">
      
        <h4 class="uppercase text-purple-600 tracking-wide text-2xl font-black text-center">No recommended chat room yet</h4>
        <img src="/no_recommended.svg" alt="no recommended chat room">
        <div v-if="isAtLargeScreen" @click="$emit('toggleIsDiscoverExpanded')" class="text-4xl bg-purple-300 rounded-full p-2 flex bg-opacity-10 hover:bg-opacity-50 pop-click w-max mx-auto">
          <ion-icon name="log-in"></ion-icon>
        </div>
      </section>
    </div>
    
  </section>

  <section  @mouseenter="isVisibleOpenDiscoverTooltip = true" @mouseleave="isVisibleOpenDiscoverTooltip = false" @click="openDiscoverTab(false)" class="bg-white bg-opacity-60 fixed right-0 top-1/4 z-40 rounded-bl-lg rounded-tl-lg shadow-xl px-1 py-2 pop-click group hidden md:block lg:hidden">
    <div class="flex flex-col space-y-2 justify-center">
      
      <div class="text-purple-600 text-2xl leading-2 h-6 w-6 overflow-hidden rounded-full opacity-90 group-hover:opacity-100 transition-all flex">

        <!-- tooltip text -->
        <transition name="slide-right">
          <div v-if="isVisibleOpenDiscoverTooltip" class="p-2 w-max bg-purple-500 rounded-tl-xl rounded-bl-xl absolute z-30 right-0 top-0 flex space-x-0.5 text-white">
            <ion-icon class="table my-auto text-lg" name="caret-back-circle"></ion-icon>
            <h6 class="text-xs table my-auto">Discover Chat Room</h6>
          </div>
        </transition>

        <ion-icon class="table m-auto" name="caret-back-circle"></ion-icon>
      </div>
      <div v-for="(chatRoom, key) in sideThumbnailRecommendedChatRoom" :key="key">
        <div class="h-5 w-5 overflow-hidden rounded-full opacity-80 group-hover:opacity-100 transition-all mx-auto">
          <img class="min-w-full min-h-full relative top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 transition-all select-none " :src="chatRoom.icon" :alt="chatRoom.name" @error="$emit('errorIcon',key)">
        </div>
      </div>

      <div v-if="sideThumbnailLimit < Object.keys(recommendedChatRoom).length" class="h-5 w-5 bg-purple-500 text-white overflow-hidden rounded-full opacity-80 group-hover:opacity-100 transition-all mx-auto flex">
        <span class="table m-auto text-xs font-bold">+{{ Object.keys(recommendedChatRoom).length - sideThumbnailLimit }}</span>
      </div>

    </div>
    </section>

     <section v-if="isSideButtonOpen" @mouseenter="isVisibleOpenDiscoverTooltip = true" @mouseleave="isVisibleOpenDiscoverTooltip = false" @click="openDiscoverTab(true)" class="bg-white bg-opacity-60 fixed right-0 top-1/4 z-40 rounded-bl-lg rounded-tl-lg shadow-xl px-1 py-2 pop-click group hidden lg:block">
    <div class="flex flex-col space-y-2 justify-center">
      
      <div class="text-purple-600 text-2xl leading-2 h-6 w-6 overflow-hidden rounded-full opacity-90 group-hover:opacity-100 transition-all flex">

        <!-- tooltip text -->
        <transition name="slide-right">
          <div v-if="isVisibleOpenDiscoverTooltip" class="p-2 w-max bg-purple-500 rounded-tl-xl rounded-bl-xl absolute z-30 right-0 top-0 flex space-x-0.5 text-white">
            <ion-icon class="table my-auto text-lg" name="caret-back-circle"></ion-icon>
            <h6 class="text-xs table my-auto">Discover Chat Room</h6>
          </div>
        </transition>

        <ion-icon class="table m-auto" name="caret-back-circle"></ion-icon>
      </div>
      <div v-for="(chatRoom, key) in sideThumbnailRecommendedChatRoom " :key="key">
        <div class="h-5 w-5 overflow-hidden rounded-full opacity-80 group-hover:opacity-100 transition-all mx-auto">
          <img class="min-w-full min-h-full relative top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 transition-all select-none " :src="chatRoom.icon" :alt="chatRoom.name" @error="$emit('errorIcon',key)">
        </div>

      </div>

      <div v-if="sideThumbnailLimit < Object.keys(recommendedChatRoom).length" class="h-5 w-5 bg-purple-500 text-white overflow-hidden rounded-full opacity-80 group-hover:opacity-100 transition-all mx-auto flex">
        <span class="table m-auto text-xs font-bold">+{{ Object.keys(recommendedChatRoom).length - sideThumbnailLimit }}</span>
      </div>
      
    </div>
    </section>
    
    <tab-container ref="tabContainer" tabName="Recommended Chat Rooms" class="lg:hidden" :isTabOpened="isDiscoverTabOpened" :willCheckScroll="true" @toggleTab="(toOpen)=>{ isDiscoverTabOpened = toOpen}" @bottomScrolled="$emit('bottomScrolled')">

      <section v-if="hasRecommendedChatRoom" class="grid grid-cols-1 sm:grid-cols-2 gap-2 w-full">
        <chat-room-card v-for="(room,key) in recommendedChatRoom" :key="key" :chatRoom="room" :chatRoomId="key" @joinChatRoom="()=>{ $emit('joinChatRoom',key) }"  @errorIcon="()=>{ $emit('errorIcon',key) }" @setChatRoomInfo="(room,key,isAlreadyMember)=>{ $emit('setChatRoomInfo',room,key,isAlreadyMember)}" :isAlreadyMember="false" :isDarkColor="true" ></chat-room-card>
        <google-loader v-if="isAddingDiscoverChatRoom"></google-loader>
      </section>

      <section v-else class="h-full space-y-5 col-span-full mx-auto">
        <h4 class="uppercase text-purple-600 tracking-wide text-xl font-bold text-center">No recommended chat room yet</h4>
        <img class="max-w-md mx-auto" src="/no_recommended.svg" alt="no recommended chat room">
      </section>

    </tab-container>
    <tab-container tabName="Search new Chat Room" :isTabOpened="searchChat.isVisible" @toggleTab="(toOpen)=>{toggleSearchChat(toOpen)}" @opened="focusOnSearchInput" class="h-48">
      <section class="max-w-md mx-auto">
        <input ref="searchRoomInput" type="search" v-model="searchChat.queryString" class="text-input-default" placeholder="Search Chat Room">

        <div v-if="searchChat.queryString === ''" class="bg-white shadow-2xl rounded-b-xl p-2 divide-y-2 divide-gray-100 text-gray-500 text-base">
          <div v-for="(query,key) in searchHistories.queries" :key="key" @click="searchChat.queryString = query" class="p-2 hover:bg-gray-200 cursor-pointer rounded-md pop-click">
            <h6>{{query}}</h6>
          </div>
          <h6 v-if="searchHistories.queries && searchHistories.queries.length < searchHistories.maxQuery" @click="getSearchHistory(searchHistories.limit + searchHistories.addPerLoad)" class="text-xs text-gray-300 hover:underline text-center cursor-pointer w-max mx-auto">View More</h6>
        </div>

        <div>
          <transition-group tag="div" name="slide-up" class="flex flex-col space-y-2 w-full my-5">
            
            <section  v-for="(chat,key) in  searchChat.queryResult" :key="key" class="relative">
              <div v-if="!chatRoomsIdList.includes(key)" @click="$emit('setChatRoomInfo',chat,key,false)" class=" p-3 md:p-2 lg:p-3 flex transition-colors  bg-purple-500 overflow-hidden  space-x-1 justify-between rounded-xl hover:bg-purple-600 pop-click">

              <div class="flex space-x-1">
                <div class="h-full my-auto">
                  <div class="my-auto w-8 lg:w-10 h-8 lg:h-10 rounded-full overflow-hidden pop-click relative">
                      <img class="w-full h-full min-w-full min-h-full absolute  top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 cursor-pointer transition-all select-none z-10" :src="chat.icon" :alt="chat.name" @error="$emit('errorIcon',key)">
                  </div>
                </div>
                
                <div  class="flex flex-col select-none justify-center text-white mx-2" >
                  <h4 class="text-sm font-medium xl:text-base line-clamp-1"> {{ chat.name }} </h4>
                </div>
              </div>

              <div>
                <div @click.stop.prevent="$emit('joinChatRoom',key)" class="rounded-md p-1 text-xs  text-white  pop-click  transition-colors hover:bg-pink-500 bg-pink-400 opacity-90 h-max">
                  <h6>Join</h6>
                </div>
              </div>

              </div>
            </section>
    
          </transition-group>
        </div>
      </section>
    </tab-container>
  </section>
  
</template>

<script>
import ChatRoomCard from '@/components/ChatRoomCard.vue';
import TabContainer from '@/components/TabContainer.vue';
import GoogleLoader from '@/components/GoogleLoader.vue';
import firebase from "firebase/app";

export default {
  data(){
    return {
      isVisibleOpenDiscoverTooltip : false,
      isDiscoverTabOpened :false,
      isAddingChatRoom : false,
      sideThumbnailLimit : 3,
      searchHistories : {
        queries : null,
        limit : 5,
        addPerLoad : 10,
        maxQuery : -1
      },
      searchChat : {
        isVisible : false,
        queryString : "",
        queryResult : {}
      },
    }
  },
  components : {
    'tab-container' : TabContainer,
    'chat-room-card' : ChatRoomCard,
    'google-loader' : GoogleLoader,
  },
  emits: ['errorIcon','toggleIsDiscoverExpanded','joinChatRoom','setChatRoomInfo','bottomScrolled'],
  mounted() {
    if(this.$refs.mainContainer)this.$refs.mainContainer.addEventListener("scroll", this.checkIfOnBottom)
  },
  beforeUnmount(){
    if(this.$refs.mainContainer)this.$refs.mainContainer.removeEventListener("scroll", this.checkIfOnBottom);
  },
  props : {
    costumizedUsersData : Object,
    currentUsersData : Object,
    recommendedChatRoom : Object,
    isAddingDiscoverChatRoom : Boolean,
    isDiscoverExpanded : Boolean,
    isAtLargeScreen : Boolean,
    usersChatRoomIds : {
      type: Array,
      default() {
        return  []
      }
    }
  },
  computed : {
    chatRoomsIdList(){
      return Object.keys(this.costumizedUsersData.chatRoomsId);
    },
    searchRoomWord(){
      return this.searchChat.queryString;
    },
    isSideButtonOpen(){
      return !this.isDiscoverExpanded;
    },
    hasRecommendedChatRoom(){
      if(this.recommendedChatRoomLength > 0)return true;
      return false;
    },
    sideThumbnailRecommendedChatRoom(){
      return Object.entries(this.recommendedChatRoom).slice(0,this.sideThumbnailLimit).map(entry => entry[1]);
    },
    recommendedChatRoomLength(){
      if(!this.recommendedChatRoom)return 0;
      return Object.keys(this.recommendedChatRoom).length;
    }
  },
  methods : {
    checkIfOnBottom() {

      if(this.isAddingChatRoom)return;
      const mainContainer  = this.$refs.mainContainer;
      const tabContainer =  this.$refs.scrollContainer;
      // console.log(mainContainer.offsetHeight + mainContainer.scrollTop, tabContainer.offsetHeight );
      if ((mainContainer.offsetHeight + mainContainer.scrollTop) >= (tabContainer.offsetHeight - 30 ) ) {
        this.isAddingChatRoom = true;
        // console.log('bot');
        this.$emit('bottomScrolled');
      }
    },
    openDiscoverTab(isAtLargeScreen = true){
      this.isVisibleOpenDiscoverTooltip = false;
      if(isAtLargeScreen)return this.$emit('toggleIsDiscoverExpanded');
      return this.isDiscoverTabOpened = true;
    },
    focusOnSearchInput(){
      setTimeout(()=>{
        if(this.$refs.searchRoomInput)this.$refs.searchRoomInput.focus();
      }, 1000);
    },
    getSearchHistory(limit  = 5){
      this.searchHistories.queries = [];
      const searchHistory = firebase.database().ref('users').child(this.currentUsersData.uid).child('searchHistory');

      searchHistory.orderByChild('date').limitToLast(limit)
      .on('value',(snapshot) => {
        this.searchHistories.queries = [];
         snapshot.forEach((childSnapshot) => {
           this.searchHistories.queries.unshift(childSnapshot.val().query);
         })
      });
      this.searchHistories.limit = limit;
      
      if(this.searchHistories.maxQuery === -1)searchHistory.on('value',(snapshot) => {this.searchHistories.maxQuery = snapshot.numChildren();});
    },
    toggleSearchChat(isVisible = null){
      if(isVisible === null)return this.searchChat.isVisible = !this.searchChat.isVisible;
      this.searchChat.isVisible = isVisible;
      if(isVisible && this.searchHistories.queries === null)this.getSearchHistory();
    },
    searchChatRoom(queryText){
      if(queryText === "")return this.searchChat.queryResult = {};
      queryText = queryText.toLowerCase();
      firebase.database().ref('chatRooms').orderByChild('nameSearch')
      .startAt(queryText)
      .endAt(queryText+"\uf8ff")
      .on("value", (snapshot)=> {
        this.searchChat.queryResult = snapshot.val();
      });
    },
  },
  watch : {
    searchRoomWord(word){
      this.searchChatRoom(word);
    },
    recommendedChatRoomLength(recommendedLength,prevRecommendedLength){
      if(recommendedLength < prevRecommendedLength){
        this.isAddingChatRoom = true;
        this.$emit('bottomScrolled');
        return;
      }
      if(this.isLimitReached)return;
      if(!this.$refs.mainContainer)return;
      this.isAddingChatRoom = false;
    }
  }

}
</script>

<style>

.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 300ms ease;
}

.slide-right-enter-from,
.slide-right-leave-to {
  opacity: 0;
  transform: translateX(30px);
}


</style>